import { useMemo } from 'react';
import { useGlobalContext } from '../../context/GlobalContext';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';


export default function useUserWelcomeCard() {
  const { usuario } = useGlobalContext();
  const {t} = useTranslation('instrutor');

  const saudacao = useMemo(
    () => dayjs().format('dddd, DD [de] MMMM [de] YYYY'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t], 
  );
  const username = usuario?.usuario || t('instrutor:user');

  return {
    saudacao,
    username,
  };
}
